<template>
    <div>
        <div class="rounded-md bg-blue-50 p-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                </div>
                <div class="ml-3">
                    <div class="text-sm text-blue-600">
                        <p>
                            <span class="font-semibold">The primary account email address will recieve notifications.</span> Each additional email address that is added below will recieve all notifications (except password resets) for this account as well.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="emails.length === 0 && !addNewEmail" class="flex items-center flex-col pb-8">
            <empty-state></empty-state>
            <button @click.prevent="addNewEmail = true" class="items-center space-x-2 px-4 py-3 font-medium rounded-md text-blue-50 bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                Add New Email
            </button>
        </div>
        <ul class="mt-6 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-3">
            <li v-for="email in emails" :key="email.id" class="relative email-wrapper col-span-1 flex shadow-sm rounded-md">
                <div class="flex-shrink-0 flex items-center justify-center w-16 bg-gray-100 text-gray-400 text-sm font-medium rounded-l-md py-8">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                </div>
                <div v-if="deleteEmail === email.id" class="absolute rounded-md bg-red-500 text-red-50 left-0 right-0 top-0 bottom-0 flex flex-col justify-center items-center">
                    <p>Confirm Delete?</p>
                    <p class="flex mt-2 items-center">
                        <a @click.prevent="destroy(email.id)" href="#" class="font-bold mr-4 px-4 py-1 border-2 border-red-300 rounded-full">Yes</a>
                        <a @click.prevent="deleteEmail = null" href="#">No</a>
                    </p>
                </div>
                <div class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                    <div class="flex-1 px-4 py-2 text-sm truncate">
                        <a href="#" class="text-gray-900 font-medium hover:text-gray-600">{{ email.email }}</a>
                    </div>
                    <div class="flex-shrink-0 pr-2">
                        <button @click="deleteEmail = email.id" class="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 delete-email">
                            <span class="sr-only">Open options</span>
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                        </button>
                    </div>
                </div>
            </li>
            <li  v-if="! addNewEmail && emails.length > 0" @click="addNewEmail = true" class="relative email-wrapper col-span-1 flex shadow-sm rounded-md text-blue-900 hover:text-blue-600 cursor-pointer">
                <div class="flex-shrink-0 flex items-center justify-center w-16 bg-blue-100 text-blue-400 text-sm font-medium rounded-l-md py-8">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                </div>
                <div class="flex-1 flex items-center justify-between border-t border-r border-b border-blue-200 bg-white rounded-r-md truncate">
                    <div class="flex-1 px-4 py-2 text-sm truncate">
                        <p class=" font-medium ">Add New Email</p>
                    </div>
                </div>
            </li>
            <li v-if="addNewEmail" class="relative email-wrapper col-span-1 flex shadow-sm rounded-md text-blue-900 hover:text-blue-600 cursor-pointer">
                <div @click.prevent="addNewEmail = false" class="absolute p-1 rounded-full bg-blue-500 text-blue-50 top-0 left-0 -ml-2 -mt-2">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                </div>
                <div class="flex-1 flex items-center justify-between bg-blue-50 border-blue-200 bg-white rounded-r-md truncate">
                    <form @submit.prevent="save" class="w-full">
                        <div class="flex-1 px-4 py-6 text-sm truncate">
                            <div class="mt-1 flex rounded-md shadow-sm">
                                <div class="relative flex items-stretch flex-grow focus-within:z-10">
                                    <input v-model="newEmail" type="email" name="email" id="email" class="px-3 py-3 text-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md font-mono border-gray-300" placeholder="Email address...">
                                </div>
                                <button class="-ml-px relative inline-flex items-center space-x-2 px-4 py-3 border border-gray-300 text-sm font-medium rounded-r-md text-blue-50 bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                                    <span>Save</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </li>

        </ul>
    </div>
</template>

<script>
import EmptyState from '@/Shared/EmptyState'
import LoadingButton from "../../Shared/LoadingButton";

export default {
    components: {
        EmptyState,
        LoadingButton
    },
    data() {
        return {
            saving: false,
            deleteEmail: null,
            addNewEmail: false,
            newEmail: null
        }
    },
    props: {
        emails: Array,
        user: Object,
    },
    methods: {
        save() {
            this.$inertia.post(
                this.route('users.notificationEmails.store', this.user.id),
                { email: this.newEmail },
                {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => {
                        this.addNewEmail = false,
                        this.newEmail = null
                    }
                }
            )
        },
        destroy(email) {
            this.$inertia.delete(
                this.route('users.notificationEmails.destroy', [this.user.id, email]),
                {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => {
                        this.deleteEmail = false
                    }
                }
            )
        }
    }
}
</script>

<style scoped>
.email-wrapper .delete-email {
    display: none;
}

.email-wrapper:hover .delete-email {
    display: block;
}
</style>
